import { render, staticRenderFns } from "./Labels.vue?vue&type=template&id=3cd7cd14&scoped=true&"
import script from "./Labels.vue?vue&type=script&lang=ts&"
export * from "./Labels.vue?vue&type=script&lang=ts&"
import style0 from "./Labels.vue?vue&type=style&index=0&id=3cd7cd14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd7cd14",
  null
  
)

export default component.exports